import { render } from "./DoctorsList.vue?vue&type=template&id=30bfa930&scoped=true"
import script from "./DoctorsList.vue?vue&type=script&lang=ts"
export * from "./DoctorsList.vue?vue&type=script&lang=ts"

import "./DoctorsList.vue?vue&type=style&index=0&id=30bfa930&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30bfa930"

export default script